import { render, staticRenderFns } from "./OrderSingleDocuments.vue?vue&type=template&id=3da1f865&"
import script from "./OrderSingleDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderSingleDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports